import { useParams } from 'react-router';

import { useEffect, useState } from 'react';

import { styled } from '@mui/material';

import { Skeleton } from '@app-velocity/ui';

import {
  ScenarioDetailsContext,
  ScenarioHeatmapContext,
  useGetScenarioQuery,
} from '@app-velocity/modules/scenarios';

import { useI18n } from '@app-velocity/i18n';

import { PrimaryPage } from '../../../../layouts';

import { TaskDescription } from './components/TaskDescription';
import { getHeatMapLayersNames } from '../../../../../core';

import { AISimulationSection } from './components/AISimulationSection/AISimulationSection';
import { HumanTestingSection } from './components/HumanTestingSection/HumanTestingSection';

const Sections = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const Details = () => {
  const { t } = useI18n();
  const [heatMapLayers, setHeatMapLayers] = useState<string[]>([]);

  const readCurrentHeatMapLayers = async () => {
    const names = await getHeatMapLayersNames();
    setHeatMapLayers(names);
  };

  useEffect(() => {
    readCurrentHeatMapLayers();

    const interval = setInterval(() => {
      readCurrentHeatMapLayers();
    }, 1500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const { workspaceId, scenarioId } = useParams<{
    workspaceId: string;
    scenarioId: string;
  }>();
  const { data: scenario } = useGetScenarioQuery(workspaceId, scenarioId);

  return (
    <PrimaryPage
      back=".."
      backLabel={t('prototypes:all_challenges')}
      title={null}
    >
      {scenario ? (
        <ScenarioDetailsContext.Provider
          value={{
            scenario: scenario,
          }}
        >
          <ScenarioHeatmapContext.Provider value={{ heatMapLayers }}>
            <Sections>
              <TaskDescription />
              <AISimulationSection />
              <HumanTestingSection />
            </Sections>
          </ScenarioHeatmapContext.Provider>
        </ScenarioDetailsContext.Provider>
      ) : (
        <Sections>
          <Skeleton height={62} />
          <Skeleton height={105} />
          <Skeleton height={140} />
        </Sections>
      )}
    </PrimaryPage>
  );
};
